import axios from 'axios';
import CookieNames from '../constants/cookie-names.constants';
import {
  REVIEWS_ADD_ITEM_FAIL,
  REVIEWS_ADD_ITEM_REQUEST,
  REVIEWS_ADD_ITEM_SUCCESS,
  REVIEWS_LIST_FAIL,
  REVIEWS_LIST_REQUEST,
  REVIEWS_LIST_SUCCESS,
  REVIEWS_SUMMARY_FAIL,
  REVIEWS_SUMMARY_REQUEST,
  REVIEWS_SUMMARY_SUCCESS,
  REVIEWS_TOGGLE_LIKE_FAIL,
  REVIEWS_TOGGLE_LIKE_REQUEST,
  REVIEWS_TOGGLE_LIKE_SUCCESS,
  USER_LIKED_REVIEWS_FAIL,
  USER_LIKED_REVIEWS_REQUEST,
  USER_LIKED_REVIEWS_SUCCESS,
} from '../constants/reviews.constants';
import { cookieService } from "../services";

export const getReviewsList =
  (typeId, rating = null, limit = 10) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: REVIEWS_LIST_REQUEST,
        payload: typeId,
      });

      const existingTypeId = getState().reviewsList.typeId;
      const reviews = getState().reviewsList.reviews;
      const beforeId = reviews.length > 0 && existingTypeId ? reviews[reviews.length - 1].id : null;

      const { data } = await axios.get(
        jsRoutes.controllers.ReviewController.list(itemId, typeId, rating, beforeId).url
      );

      dispatch({
        type: REVIEWS_LIST_SUCCESS,
        payload: {
          reviews: existingTypeId === typeId ? [...reviews, ...data.reviews] : data.reviews,
          isLastPage: data.isLastPage,
        },
      });
    } catch (error) {
      dispatch({
        type: REVIEWS_LIST_FAIL,
        payload: error.response || 'Failed retrieving reviews',
      });
    }
  };

export const getReviewsSummary = (typeId) => async (dispatch) => {
  try {
    dispatch({
      type: REVIEWS_SUMMARY_REQUEST,
      payload: typeId,
    });

    const { data } = await axios.get(jsRoutes.controllers.ReviewController.summary(undefined, typeId).url);

    dispatch({
      type: REVIEWS_SUMMARY_SUCCESS,
      payload: {
        totalCount: data.totalCount,
        rating: data.rating,
        ratingPercent: data.ratingPercent,
        ratings: data.ratings,
      },
    });
  } catch (error) {
    dispatch({
      type: REVIEWS_SUMMARY_FAIL,
      payload: error.response || 'Failed retrieving reviews summary',
    });
  }
};

export const getUserLikedReviews = () => async (dispatch) => {
  const nameCookie = cookieService.get(CookieNames.NAME);

  if (!!nameCookie) {
    try {
      dispatch({ type: USER_LIKED_REVIEWS_REQUEST });

      const { data } = await axios.get(jsRoutes.controllers.ReviewController.userLikes().url, {
        headers: {
          'Ignore-Interceptors': true,
        },
      });

      dispatch({
        type: USER_LIKED_REVIEWS_SUCCESS,
        payload: data.likedReviewIds,
      });
    } catch (error) {
      dispatch({
        type: USER_LIKED_REVIEWS_FAIL,
        payload: error.response?.data || error.message || 'Failed retrieving user liked reviews',
      });
    }
  }
};

export const toggleReviewLike = (id) => async (dispatch, getState) => {
  const nameCookie = cookieService.get(CookieNames.NAME);

  if (!!nameCookie) {
    try {
      dispatch({ type: REVIEWS_TOGGLE_LIKE_REQUEST });

      const isLiked = getState().likedReviews.likedReviewIds.indexOf(id) >= 0;
      await axios.post(jsRoutes.controllers.ReviewController.setLikeStatus(id, !isLiked).url);

      const locallyChanged = [...getState().reviewsLikeToggle.locallyChanged];
      const locallyChangedId = locallyChanged.findIndex((i) => i.id === id);

      if (locallyChangedId >= 0) {
        locallyChanged.splice(locallyChangedId, 1);
      } else {
        locallyChanged.push({
          id,
          value: !isLiked,
        });
      }

      dispatch({
        type: REVIEWS_TOGGLE_LIKE_SUCCESS,
        payload: locallyChanged,
      });

      const userLikedReviewIds = !isLiked
        ? [...getState().likedReviews.likedReviewIds, id]
        : [...getState().likedReviews.likedReviewIds.filter((i) => i !== id)];

      dispatch({ type: USER_LIKED_REVIEWS_SUCCESS, payload: userLikedReviewIds });
    } catch (error) {
      dispatch({
        type: REVIEWS_TOGGLE_LIKE_FAIL,
        error: 'Failed liking/disliking review',
      });
    }
  }
};

export const addReview =
  ({ rating, title, body = '', images = [], itemId }) =>
  async (dispatch) => {
    try {
      dispatch({ type: REVIEWS_ADD_ITEM_REQUEST });

      const formData = new FormData();
      formData.append('title', title);
      formData.append('rating', rating);
      formData.append('body', body);
      formData.append('itemId', itemId);

      if (images.length > 0) {
        for (let i = 0; i < images.length; i++) {
          formData.append(`images[${i}]`, images[i]);
        }
      }

      await axios.post(jsRoutes.controllers.ReviewController.create().url, formData, {
        headers: {
          'content-type': 'multipart/form-data',
        },
      });

      dispatch({ type: REVIEWS_ADD_ITEM_SUCCESS });
    } catch (error) {
      dispatch({
        type: REVIEWS_ADD_ITEM_FAIL,
        payload: error.response?.message || error.response || 'Failed adding review',
      });
    }
  };
